var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 277.2 198.2",
    style: {
      enableBackground: "new 0 0 277.2 198.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB2D2A;}\r\n\t.st1{fill:#0D203B;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,157.5h20c0.8,0,1.5-0.7,1.5-1.5l0,0c0-0.8-0.7-1.5-1.5-1.5h-20V24.8H93.7v32h24.8v100.7h35.9v5.9l0,0 v0.9l0,0v1c-1.1,0-2.1-0.1-3.2-0.2c-2.1-2.5-4.6-4.3-7.3-3.5c-2.5,0.7-2.8,2-2.6,2.9c0.4,2,3.9,3,8.3,3.4c2,2.9,3.7,6,5,9.3 c0.2,0.6,0.8,1,1.4,1c0.8,0,1.5-0.7,1.5-1.5v-8.4c2.2,0,4.2-0.1,5.8-0.2c0.8-0.1,1.4-0.8,1.3-1.6c0-0.8-0.6-1.4-1.4-1.4 c-0.1,0-0.1,0-0.2,0c-2,0.2-3.9,0.2-5.6,0.3v-1.1l0,0L157.4,157.5z M154.5,169.9c-0.3-0.6-0.6-1.2-1-1.7h1V169.9z M121.5,154.5 V53.8H96.7v-26h57.7v126.7H121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,152.8h20c0.8,0,1.5-0.7,1.5-1.5l0,0c0-0.8-0.7-1.5-1.5-1.5h-20V20.1H98.4v32h24.8v100.7h35.9v5.9l0,0 v0.9l0,0v1c-1.1,0-2.1-0.1-3.2-0.2c-2.1-2.5-4.6-4.3-7.3-3.5c-2.5,0.7-2.8,2-2.6,2.9c0.4,2,3.9,3,8.3,3.4c2,2.9,3.7,6,5,9.3 c0.2,0.6,0.8,1,1.4,1c0.8,0,1.5-0.7,1.5-1.5v-8.4c2.2,0,4.2-0.1,5.8-0.2c0.8-0.1,1.4-0.8,1.3-1.6c0-0.8-0.6-1.4-1.4-1.4 c-0.1,0-0.1,0-0.2,0c-2,0.2-3.9,0.2-5.6,0.3v-1.1l0,0L162.1,152.8L162.1,152.8z M159.1,165.2c-0.3-0.6-0.6-1.2-1-1.7h1V165.2z  M126.2,149.8V49.1h-24.8v-26h57.7v126.7H126.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/number-1.80c0f7e3c257b92be81c3caba2a0c207.svg";
export { ForwardRef as ReactComponent };